import { render, staticRenderFns } from "./ObrigadoAlmaGemeaCakto.vue?vue&type=template&id=52046aa8"
import script from "./ObrigadoAlmaGemeaCakto.vue?vue&type=script&lang=js"
export * from "./ObrigadoAlmaGemeaCakto.vue?vue&type=script&lang=js"
import style0 from "./ObrigadoAlmaGemeaCakto.vue?vue&type=style&index=0&id=52046aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports